// extracted by mini-css-extract-plugin
export var colorStyle = "PrivacyPolicyLink-module__colorStyle___w7HVh";
export var link = "PrivacyPolicyLink-module__link___ARFQD";
export var linkBig = "PrivacyPolicyLink-module__linkBig___5Yd5b";
export var linkContainer = "PrivacyPolicyLink-module__linkContainer___z-HFO";